import { FormikHelpers } from "formik";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfUnitSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import UnitsSearchForm from "./UnitsSearchForm";

const emptyUnitSearchForm: IUnitSearchForm = {
  description: "",
  sapCode: "",
  unID: "",
  deleted: "",
  placeID: ""
};

const SearchUnit = ()  => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfUnitSearchForm(activeFilters) ? activeFilters as IUnitSearchForm : emptyUnitSearchForm;

  const handleSubmit = async (values: IUnitSearchForm, { setSubmitting }: FormikHelpers<IUnitSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <UnitsSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}


export default SearchUnit;